import React from "react";

export const Home = () => {
  return (
    <div>
      <div className="Homepagehero min-h-screen bg-srs-srsbg">
        <div className="flex text-center justify-center">
          <img
            src="/Otherside.png"
            alt="Otherside By Salt River Shakedown"
            className="w-72 mt-6"
          />
        </div>

        <div className="flex justify-center items-center flex-col">
          <img
            src="/OthersidePic.png"
            alt="Otherside By Salt River Shakedown"
            className="w-72 sm:w-96 border-4 rounded-lg"
          />
          <div className="flex align-bottom">
            <div className="align-bottom">
              <div className="">
                <iframe
                  src="https://open.spotify.com/embed/track/72hCEWs4lozZ50taI5mItw?utm_source=generator"
                  width="100%"
                  height="100"
                  allowFullScreen=""
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                  className=" sm:w-96"
                ></iframe>
              </div>
            </div>
          </div>
          <div className=" text-white my-0 mx-3 sm:mx-20 text-lg">
            <h2 className=" text-center font-bold text-2xl my-3">
              Stream it Now!
            </h2>
            <p className="mb-4 mx-2 text-lg sm:text-2xl sm:mx-10">
              The new single from SRS is avalible
              now to stream on spotify, or to buy from anywhere you get your
              music.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};
